import React from 'react'
import PropTypes from 'prop-types'
import '../lead-generation.css'
import PageStatus from '../components/PageStatus'
import TemplateFrame from '../components/TemplateFrame'
import { usePublicPage } from '../hooks/usePublicPage'

function PublicPage({ onFormSubmit, prepareDocument }) {
  const { status, page, error } = usePublicPage()

  if (status !== 'success') return <PageStatus status={status} error={error} />

  if (page.templateContent) {
    return (
      <TemplateFrame
        html={page.templateContent}
        title={page.pageTitle}
        onFormSubmit={onFormSubmit && ((form, values) => onFormSubmit(page, form, values))}
        prepareDocument={prepareDocument}
      />
    )
  }

  return (
    <main className="lg-status">
      <h1>{page.pageTitle}</h1>
      {page.pageDescription && <p>{page.pageDescription}</p>}
    </main>
  )
}

PublicPage.propTypes = {
  onFormSubmit: PropTypes.func,
  prepareDocument: PropTypes.func,
}

export default PublicPage
